<template>
  <ion-toolbar>
    <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length || routeName == 'profile_covid_cert' || stepCovid">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
     <ion-buttons v-if="routeName != 'profile_covid_cert'" slot="end">
     <ion-button @click="skip">
     <span>Skip</span>
     </ion-button>
     </ion-buttons>
  </ion-toolbar>
  <div class="main_wrapper ion-padding ">
    <div class="page_title">
      Immunisation Certificates
      <el-progress class="progress" :percentage="99" :show-text="false" color="#2463FF" />
    </div>
    <el-form
        v-if="files.length <= 1"
        class="full_page"
        :model="formsData.userForm"
        :rules="formsData.userForm.rules"
        :ref="(el) => (formsData.userForm.ref = el)"
        :label-position="'top'"
        @submit.prevent="goNext('userForm', stepCovid ? true : false)"
    >
      <div>
        <div class="text">
          Please upload proof of your vaccination details. <br/><br/>
          <b> Evidence of your vaccination can include:</b>
          <ul class="">
            <li>Immunisation history statement available from Medicare</li>
            <li>MyGov COVID digital certificate</li>
            <li>
              My Health Record and Medicare online account Proof of relevant
              medical exemption (e.g. a letter from a GP)
            </li>
          </ul>
        </div>
      </div>

      <el-form-item
          class="covid-cert-select"
          prop="certStatus"
          style="width: 100%;"
          label="Have you been vaccinated?"
          :required="true"
      >
        <el-select
            style="width: 100%;"
            v-model="formsData.userForm.certStatus.value"
            placeholder="Select"
            @change="changeCount()"
        >
          <el-option
              v-for="item in certOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div class="form_text">

        <br/>

        <br/>
        <ul>
          <li>
            Immunisation history statement available from Medicare
          </li>
          <li>
            <a
                href="https://www.health.gov.au/initiatives-and-programs/covid-19-vaccines/certificates"
            >MyGov COVID certificate</a
            >
          </li>
          <li>
            My Health Record and Medicare online account
          </li>
          <li>
            Proof of relevant medical exemption (e.g. a letter from a GP)
          </li>
        </ul>
      </div>

      <el-form-item
          prop="files"
          v-if="
          formsData.userForm.certStatus.value == 1 && !files.length  ||
            formsData.userForm.certStatus.value == 2 ||
            formsData.userForm.certStatus.value == 3
        "
      >
      <div  class="max-text"> (maximum upload - 2 file)</div>
        <el-upload
            class="uploader-support"
            :action="'upload'"
            name="files"
            list-type="picture"
            :thumbnail-mode="true"
            :on-preview="cropperMethods.handlePreview"
            :auto-upload="false"
            multiple
            :limit="formsData.userForm.certStatus.value"
            :on-exceed="cropperMethods.handleExceed"
            :drag="true"
            :on-change="cropperMethods.handleChange"
            :before-upload="cropperMethods.beforeAvatarUpload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <template #file="{ file }">
                  <div>
                    <div v-if="file.raw.type=='application/pdf'">
                      <span class="locumate_icons locumate_icon-picture"></span>
                    </div>
                    <div v-else>
                      <img class="el-upload-list__item-thumbnail" :src="file.url" alt=""/>
                    </div>
                    <span class="el-upload-list__item-actions">
                    
                      <span
                        class="el-upload-list__item-delete"
                        @click="cropperMethods.handleRemove(file)"
                      >
                      <i class="el-icon-close"></i>
                      </span>
                    </span>
                  </div>
          </template>
        </el-upload>
      </el-form-item>

      <el-form-item
          v-if="
          (formsData.userForm.certStatus.value == 1 || formsData.userForm.certStatus.value == 2) && !files.length 
        "
          prop="vaccinationDate"
          label="'First vaccination date"
          :required="true"
      >
      
        <el-date-picker
            type="date"
            :format="$filters.systemDateFormat()"
            placeholder="Pick a date"
            v-model="formsData.userForm.vaccinationDate.value.firstDate"
            @blur="checkFormValidation('userForm', true, 'vaccinationDate')"
            @change="onChangeUpload"
            style="width: 50%;"
        ></el-date-picker>
      </el-form-item>

      <el-form-item
          prop="vaccinationDate"
          v-if="
          formsData.userForm.certStatus.value == 2 && files.length >= 0
        "
          label="'Second vaccination date"
          :required="true"
      >
        <el-date-picker
            :format="$filters.systemDateFormat()"
            placeholder="Pick a date"
            v-model="formsData.userForm.vaccinationDate.value.secondDate"
            style="width: 50%;"
            @blur="checkFormValidation('userForm', true, 'vaccinationDate')"
            @change="onChangeUpload"
        ></el-date-picker>
      </el-form-item>

      <el-form-item class="button_submit mb0">
        <el-button class="submit" type="blue" :disabled="disabled" @click="goNext('userForm')">
          <span v-if="routeName == 'profile_covid_cert'">Submit <i class="el-icon-right"></i></span>
          <span v-else>Continue <i class="el-icon-right"></i></span>
          
        </el-button>
      </el-form-item>
    </el-form>
    <div class="form_text" v-else>
      <div class="">
        You have uploaded the max number of certificates
      </div>
    </div>
    <div
        class="preview_square"
        v-if="files.length && routeName === 'profile_covid_cert'"
    >
      <div class="el-upload-list">
        <div class="el-upload-list__item" v-for="(file,index) in files" :key="file.url">
          <div class="thumbnail_img el-upload-list--picture-card">
            <div v-if="file.extension == 'pdf'"> 
              <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
            </div>
            <div v-else>
              <img
              class="el-upload-list__item-thumbnail"
              :src="file.url"
              alt=""
            />
            </div>
            <span class="el-upload-list__item-actions">
              <span
                  class="el-upload-list__item-preview"
                  @click="certPreviewModalOpen(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>

              <span
                  class="el-upload-list__item-delete"
                  @click="fileDelete(file,index)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
          <div v-if="file?.data?.date2 != null">
          <div v-if="file?.data?.date2 != null">
            <span>{{ $moment( file?.data?.date2, "YYYY-MM-DD").format("DD/MM/YYYY") }}</span>
          </div>
          </div>
          <div v-else>
            <div v-if="file?.data?.date1 != null">
            <span>{{ $moment( file?.data?.date1, "YYYY-MM-DD").format("DD/MM/YYYY") }}</span>
          </div>
          <div v-else>
            no date given
          </div>
          </div>
         
          
          

        </div>
      </div>
    </div>
  </div>
  <cert-preview-modal
      :modalName="'certPreviewModal'"
      :options="certPreviewModal"
  />
</template>

<script>
import {onMounted, inject, ref} from "vue";
import formHooks from "@/hooks/form/form";
import {addIcons} from "ionicons";
import {arrowBackOutline} from "ionicons/icons";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import FileHelpers from "@/helpers/file/file";
import {IonToolbar, IonButton, IonButtons, IonIcon} from "@ionic/vue";
import {useStore} from "vuex";
import {ElMessage, ElMessageBox} from "@/components/Vendor/Element";
import formValidate from "@/hooks/form/validate/validate";
import {useRouter, useRoute} from "vue-router";
import {CertPreviewModal} from "@/modals/modals";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    "cert-preview-modal": CertPreviewModal,
  },

  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const setPageClassGlobal = inject(["setPageClassGlobal"]);
    const moment = inject(["$moment"]);
    let stepCovid = ref(false);
    const routeName = $route.name;
    const BASE_URL = process.env.VUE_APP_BASEURL;
    const userData = $store.getters.GET_USER_DATA;
    const $modals = inject("$modals");
    const files = ref(userData.covidCert);
    const fileHelpers = new FileHelpers();
    const state = userData.address.state;
    let dialogVisible = true;
    let disabled = ref(true);
    const certPreviewModal = ref({
      name: "certPrev",
      file: [],
    });
    const certPreviewModalOpen = (file) => {
      if(file.extension == 'pdf'){
        window.open(file.url, '_blank');
      }else{
      certPreviewModal.value.file = file;
      $modals.open("certPreviewModal", {
        file: file,
      });
    }
    };
    const formsDataArray = {
      userForm: {
        files: {
          ref: null,
          value: [],
          limit: 10,
          disabled: false,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                    rule,
                    formField,
                    "gallery",
                    callback,
                    setFormValidation
                );
              },
            },
          ],
          errors: null,
        },

        certStatus: {
          ref: null,
          value: 0,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                    rule,
                    formField,
                    {
                      rule: "covidCertTrue",
                    },
                    callback,
                    setFormValidation
                );
              },
            },
          ],
        },

        vaccinationDate: {
          ref: null,
          value: {
            firstDate: "",
            secondDate: "",
          },
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                    rule,
                    formField,
                    {
                      rule: "vaccinationDate",
                    },
                    callback,
                    setFormValidation
                );
              },
            },
          ],
        },
      },
    };
    Object.assign(formsDataArray.userForm, formsDataArray);

    const onChangeUpload = () => {
            
        if (formsData.userForm.files.value.length > 0) {
            if(formsData.userForm.certStatus.value == 1 && moment(formsData.userForm.vaccinationDate.value.firstDate, "YYYY-MM-DD")<= new Date()){
              disabled.value = false;
            }else if(formsData.userForm.certStatus.value == 2 && moment(formsData.userForm.vaccinationDate.value.firstDate, "YYYY-MM-DD")<= new Date() && moment(formsData.userForm.vaccinationDate.value.secondDate, "YYYY-MM-DD")<= new Date()&& formsData.userForm.vaccinationDate.value.firstDate != null && formsData.userForm.vaccinationDate.value.secondDate != null && (moment(formsData.userForm.vaccinationDate.value.firstDate, "YYYY-MM-DD") < moment(formsData.userForm.vaccinationDate.value.secondDate, "YYYY-MM-DD")) ){
              console.log("2 in");
              
              disabled.value = false;
            }else if(formsData.userForm.certStatus.value == 3){
              disabled.value = false;
            }
            else if(routeName != "profile_covid_cert"){
              disabled.value = false;
            }else{
              disabled.value = true;
            }
          // disabled.value = false;
          }else{
            disabled.value = true;
          }
    };
    const setOption = (value) => {
      formsData.userForm.certStatus.value = value;
    };
    const selectOptions = (selectedOption) => {
      setOption(selectedOption.value);
    };
    const certOptions = [
      {
        label: "I am not vaccinated",
        value: 0,
      },
      {
        label: "I have received at least one dose of the COVID vaccine",
        value: 1,
      },
      {
        label: "I am fully vaccinated with two doses of the COVID vaccine",
        value: 2,
      },
      {
        label:
            "I have a medical exemption evidenced by an authorised medical practitioner",
        value: 3,
      },
    ];

    const cropperMethods = {
      beforeAvatarUpload(file) {
        const img = URL.createObjectURL(file.raw);
        console.log(img);
      },
      handleRemove(file) {
        formsData.userForm.files.splice(
            formsData.userForm.files.indexOf(file),
            1
        );
        onChangeUpload();
      },
      handleChange(file, files) {
        const type = fileHelpers.getFileType(file);
        console.log(type);
        if (type == "image" || type == "pdf") {
          formsData.userForm.files = files;
          formsData.userForm.files.value = files;
          checkFormValidation("userForm", true, "files");
        } else {
          files.pop();
          formsData.userForm.files.value = null;
          ElMessage({
            type: "error",
            message: `Certificate   must be JPG JPEG PNG JFIF or PDF format!`,
          });
        }
        onChangeUpload();
      },

      handlePreview(/*file*/) {
      },
      handleExceed(file, files) {
        console.log(file);
        ElMessage({
          type: "error",
          message: `The limit is ${formsData.userForm.certStatus.value}, you selected ${files.length} `,
        });
      },
    };

    const goBack = async() => {
      if (stepCovid.value) {
        stepCovid.value = !stepCovid.value;
      } else if (routeName == "profile_covid_cert") {
        $router.push({
          name: "profile_documents",
        });
      } else {
        const back = await $store.dispatch("getAuthPageBack");
        $router.push({
            name: back,
        });
      }
    };

    const goNext = () => {
      const canvas = formsData.userForm.files.value;
      const form = new FormData();
      let counter = 0;
      if (formsData.userForm.certStatus.value == 1) {
        if (canvas.length != 0) {
          canvas.map((item) => {
            form.append(`covid_certs[${counter}][file]`, item.raw);
            counter++;
          });
          formsData.userForm.vaccinationDate.value.firstDate
              ? form.append(
              `covid_certs[0][date1]`,
              moment(formsData.userForm.vaccinationDate.value.firstDate).format(
                  "YYYY-MM-DD"
              )
              )
              : null;
        } else {
          ElMessage({
            showClose: "true",
            type: "warning",
            message: " Please upload the file",
          });
          console.log("error submit!!");
          return false;
        }
      } else if (formsData.userForm.certStatus.value != 0)  {
        if (canvas.length == 1) {
          canvas.map((item) => {
            form.append(`covid_certs[${counter}][file]`, item.raw);
            counter++;
          });
          formsData.userForm.vaccinationDate.value.firstDate
              ? form.append(
              `covid_certs[0][date1]`,
              moment(formsData.userForm.vaccinationDate.value.firstDate).format(
                  "YYYY-MM-DD"
              )
              )
              : null;
          formsData.userForm.vaccinationDate.value.secondDate
              ? form.append(
              ` covid_certs[0][date2]`,
              moment(formsData.userForm.vaccinationDate.value.secondDate).format(
                  "YYYY-MM-DD"
              )
              )
              : null;
        } else if (canvas.length == 2) {
          canvas.map((item) => {
            form.append(`covid_certs[${counter}][file]`, item.raw);
            counter++;
          });
          formsData.userForm.vaccinationDate.value.firstDate
              ? form.append(
              `covid_certs[0][date1]`,
              moment(formsData.userForm.vaccinationDate.value.firstDate).format(
                  "YYYY-MM-DD"
              )
              )
              : null;
          formsData.userForm.vaccinationDate.value.secondDate
              ? form.append(
              ` covid_certs[1][date1]`,
              moment(formsData.userForm.vaccinationDate.value.secondDate).format(
                  "YYYY-MM-DD"
              )
              )
              : null;
        } else if (canvas.length == 0) {
          ElMessage({
            showClose: "true",
            type: "warning",
            message: " Please upload the file",
          });
          console.log("error submit!!");
          return false;
        }
      }


      form.append(
          "vaccination_proof_type",
          formsData.userForm.certStatus.value
      );

      (async () => {
        try {
          await $store.dispatch("SAVE_USER_DATA", form);

          if (routeName == "profile_covid_cert") {
            $router.push({
                  name: "profile_documents",
                });
          } else {
            if (state == "VIC" || state == "Victoria") {
              $router.push({
                name: "personal_cert",
              });
            } else {
              $router.push({
                name: "intro",
              });
            }
          }
        } catch (error) {
          console.log("error submit", error);

          let item;
          for (item in error) {
            ElMessage({
              showClose: "true",
              type: "error",
              message: error[item][0],
            });
          }
        }
      })();
    }


const fileDelete = async (file,index) => {
  try {
    await ElMessageBox.confirm(
        `Are you sure you’d like to remove file ?`,
        "Remove file",
        {
          confirmButtonText: "Remove",
          cancelButtonText: "Cancel",
          confirmButtonClass: "el-button--red",
          cancelButtonClass: "el-button--grey",
          showClose: false,
        }
    );
    await $store.dispatch("DELETE_USER_COVID_CERT", file);
    files.value.splice(index, 1);
  } catch (error) {
    console.log(error);
  }
};

const skip = () => {
  $store.dispatch("addAuthPageBack", $route.name);
  if (routeName == "profile_covid_cert") {
    $router.push({
      name: "profile",
    });
  } else {
    if (state == "VIC" || state == "Victoria") {
      $router.push({
        name: "personal_cert",
      });
    } else {
      $router.push({
                name: "intro",
              });
    }
  }
};

onMounted(() => {
  setPageClassGlobal("global_auth_page");
  checkFormValidation("userForm", false);
  setFormRefs();
});

const changeCount = () => {
  checkFormValidation("userForm", true, "covidCertTrue");
  console.log("previous files", files);
  // v-for="(file,index) in files" :key="file.url"
  if(files.value.length > 0){
    console.log('yes im greater')
    files.value.forEach((file) => {
      formsData.userForm.vaccinationDate.value.firstDate =new Date(file?.data?.date1)
    })
  }else{

    formsData.userForm.vaccinationDate.value.firstDate = "";
  }
  formsData.userForm.vaccinationDate.value.secondDate = "";
  onChangeUpload();
};

const {
  checkFormValidation,
  setFormValidation,
  setFormRefs,
  getFormValues,
  formsData,
} = formHooks(formsDataArray);

return {
  formsData,
  goBack,
  skip,
  goNext,
  checkFormValidation,
  routeName,
  cropperMethods,
  stepCovid,
  files,
  fileDelete,
  selectOptions,
  changeCount,
  certOptions,
  state,
  BASE_URL,
  getFormValues,
  dialogVisible,
  certPreviewModalOpen,
  certPreviewModal,
  disabled,
  onChangeUpload
};
},
}
;
</script>